import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Typography, Checkbox, FormControlLabel, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import StepIndicator from './StepIndicatorMethod';
import InternetSignal from '../camera-module/internet-strength/InternetSignal';
import './TermAndConditions.css';

const TermsAndConditions = () => {
  const navigate = useNavigate();
  const { audit_id, method } = useParams();
  const query_icon = `${process.env.PUBLIC_URL}/custom-icons/query.png`;
  
  const [inspectionAgreed, setInspectionAgreed] = useState(false);
  const [otherTnC, setOtherTnC] = useState(false);
  const [speed, setSpeed] = useState(null);

  const handleBack = () => {
    navigate(-1);
  };


  const handleProceed = () => {
    try{
        if (inspectionAgreed) {
            const hostname = window.location.hostname;
            const port = window.location.port;
            let baseURL;
            if (port !== '') {
            baseURL = `https://${hostname}:${port}`;
            } else {
            baseURL = `https://${hostname}`;
            }
        // Navigate to next step or inspection screen
        window.location.href = `${baseURL}/audit/${method}/permission/${audit_id}`;
        }
    }catch(error){
        console.log(error, 'error');
    }
  };

  return (
    <div
      style={{
        maxWidth: '600px',
        width: '100%',
        margin: '0px auto',
        position: 'relative',
        height: '100svh',
      }}
    >
      {speed !== null && <InternetSignal signalStrength={speed} />}

      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '1rem',
          // backgroundColor: 'white',
        }}
      >
        <ArrowBackIcon
          onClick={handleBack}
          sx={{ cursor: 'pointer', color: '#000' }}
        />
        <Box sx={{ flex: 1 }} />
        <img
          src={query_icon}
          alt="Query Icon"
          style={{ width: '24px', height: '24px', cursor: 'pointer' }}
        />
      </Box>

      <Box sx={{ p: 3, maxWidth: 400, mx: 'auto', mt: '10px' }}>
        <StepIndicator stepNumber={1} lineWidth="200px" />
        
        <Typography
          variant="h6"
          fontWeight="bold"
          align="center"
          fontFamily="Montserrat, sans-serif"
          sx={{ mb: '30px', fontSize: '14px', color: '#000000DE', mt: '20px' }}
        >
          Terms & Conditions
        </Typography>

        <Typography
          variant="h4"
          fontWeight="600"
          align="center"
          fontFamily="Barlow Condensed"
          sx={{ mb: '40px', mt: 1, fontSize: '30px', color: '#000000DE' }}
        >
          Terms & Conditions
        </Typography>

        {/* Checkbox Cards */}
        <Box
          sx={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '1rem',
            mb: 2,
            border: '1px solid #e0e0e0',
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={inspectionAgreed}
                onChange={(e) => setInspectionAgreed(e.target.checked)}
                sx={{
                  color: '#FC350B',
                  '&.Mui-checked': {
                    color: '#FC350B',
                  },
                }}
              />
            }
            label={
              <Typography
                fontFamily="Montserrat, sans-serif"
                sx={{ fontSize: '14px', color: '#000000DE' }}
              >
                I agree to the inspection
              </Typography>
            }
          />
        </Box>

        <Box
          sx={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '1rem',
            mb: '100px',
            border: '1px solid #e0e0e0',
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={otherTnC}
                onChange={(e) => setOtherTnC(e.target.checked)}
                sx={{
                  color: '#999',
                  '&.Mui-checked': {
                    color: '#FC350B',
                  },
                }}
              />
            }
            label={
              <Typography
                fontFamily="Montserrat, sans-serif"
                sx={{ fontSize: '14px', color: '#000000DE' }}
              >
                Other T&C
              </Typography>
            }
          />
        </Box>

        {/* Proceed Button */}
        <Button
          fullWidth
          disabled={!inspectionAgreed}
          onClick={handleProceed}
          sx={{
            backgroundColor: inspectionAgreed ? '#FC350B' : '#e0e0e0',
            color: inspectionAgreed ? 'white' : '#999',
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '1rem',
            fontWeight: '600',
            padding: '0.8rem',
            borderRadius: '8px',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: inspectionAgreed ? '#FC350B' : '#e0e0e0',
            },
            '&:disabled': {
              backgroundColor: '#e0e0e0',
              color: '#999',
            },
          }}
        >
          Proceed to inspection
        </Button>
      </Box>
    </div>
  );
};

export default TermsAndConditions;